import uuidHex from '@utils/uuid-hex'

// the chat message as the screens build it
export type SendMessagesReqPayload = {
  message_id: string
  room_id: number
  user_id: string
  walrus_ai?: boolean
  type: number
  text: string
  client_created: string
}

// the message Flipper's websocket expects
export type FlipperSendMessageReqPayload = {
  id: string
  type: 'MESSAGE' | 'SYSTEM' | 'TYPING'
  value: string
  owner_id: number
  walrus_ai?: boolean
  room: number
  timestamp: string
}

export function converMessagePayloadToFlipper(
  sendMessagePayload: SendMessagesReqPayload
): FlipperSendMessageReqPayload {
  const uniqueId = sendMessagePayload.message_id || uuidHex()

  return {
    id: typeof uniqueId === 'string' ? uniqueId.replace(/-/g, '') : '',
    type: 'MESSAGE',
    value: sendMessagePayload.text,
    owner_id: Number(sendMessagePayload.user_id),
    room: sendMessagePayload.room_id,
    timestamp: sendMessagePayload.client_created
  }
}
